import { computed, debug, helpers, observable } from "aaa";
import * as OptioPayMockAPI from "components/optiopay/OptioPayMockAPI";
import * as _ from "lodash";
import { orderBy } from "lodash";
import { OptioPayAPIClient } from "network/APIClient";
import * as OptioPayAPI from "network/OptioPayAPI";
import { IOptioPayVouchersResponse } from "types/optioPay";

export class OptioPayVouchersStore {
    @observable vouchersResponse?: IOptioPayVouchersResponse;

    @observable _isLoading = false;

    @computed get isLoading() {
        return this._isLoading;
    }

    @computed get vouchers() {
        return orderBy(this.vouchersResponse?.vouchers ?? [], voucher => new Date(voucher.purchasedAt), "desc");
    }

    async load(): Promise<IOptioPayVouchersResponse> {
        const target = OptioPayAPI.vouchers();

        this._isLoading = true;

        try {
            const response = OptioPayMockAPI.USE_MOCK_RESPONSE
                ? OptioPayMockAPI.vouchersResponse
                : await OptioPayAPIClient.requestType(target);

            debug.log("### OptioPay.loadVouchers", response);

            this.vouchersResponse = response;
            return response;
        } catch (err) {
            debug.log("### Error OptioPay.loadVouchers", err);
            throw err;
        } finally {
            this._isLoading = false;
        }
    }

    @computed get totalSavingsBoost() {
        return helpers.numberToCurrencyString(
            (_.sumBy(this.vouchers, ({ exchangeValue }) => exchangeValue.amount / 100) || 0) -
            (_.sumBy(this.vouchers, ({ purchaseValue }) => purchaseValue.amount / 100) || 0)
        );
    }

}




// WEBPACK FOOTER //
// ./src/stores/OptioPayVouchersStore.ts